"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var EducationItem_1 = require("./parts/EducationItem");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var validations_1 = require("lib/functions/validations");
var findErrors_1 = require("lib/functions/findErrors");
var moment_1 = __importDefault(require("moment"));
var datetime = validations_1.date.datetime;
var rules = {
    high_school: validations_1.mandatory,
    high_school_address: validations_1.mandatory,
    high_school_from: __assign(__assign({}, validations_1.mandatory), validations_1.date),
    high_school_to: function (value, attributes) {
        return __assign(__assign({}, validations_1.mandatory), { datetime: __assign(__assign({}, datetime), { earliest: moment_1.default(attributes.high_school_from) }) });
    },
    graduated_from_high_school: validations_1.radioButton,
    high_school_degree: function (value, attributes) {
        if (attributes.graduated_from_high_school === "yes") {
            return __assign({}, validations_1.mandatory);
        }
        else {
            return null;
        }
    },
    college_degree: function (value, attributes) {
        if (attributes.graduated_from_college === "yes") {
            return __assign({}, validations_1.mandatory);
        }
        else {
            return null;
        }
    },
    other_college_degree: function (value, attributes) {
        if (attributes.graduated_from_other_college === "yes") {
            return __assign({}, validations_1.mandatory);
        }
        else {
            return null;
        }
    }
};
var Education = (function (_super) {
    __extends(Education, _super);
    function Education(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.educationSections = [
            {
                id: "high_school",
                name: "High School",
                required: true
            },
            {
                id: "college",
                name: "College",
                required: false
            },
            {
                id: "other_college",
                name: "Other college",
                required: false
            }
        ];
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Education.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    Education.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("validateEducation", this.isValid);
                return [2];
            });
        });
    };
    Education.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateEducation");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Education.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        this.forceUpdate();
    };
    Education.prototype.isValid = function () {
        console.log("Validate Education");
        rules = validations_1.checkDates("college_from", "college_to", this.json_data, rules);
        rules = validations_1.checkDates("other_college_from", "other_college_to", this.json_data, rules);
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        if (this.errors) {
            console.log("education errors", this.errors);
        }
        return isValid;
    };
    Education.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "EDUCATION"),
            this.educationSections.map(function (ed) { return (React.createElement(EducationItem_1.EducationSection, { key: ed.id, id: ed.id, name: ed.name, required: ed.required, json_data: json_data, onChange: onChange, errors: errors })); })));
    };
    __decorate([
        mobx_1.observable
    ], Education.prototype, "errors", void 0);
    Education = __decorate([
        mobx_react_1.observer
    ], Education);
    return Education;
}(react_1.Component));
exports.Education = Education;
//# sourceMappingURL=data:application/json;base64,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